export const urlDomain = () => {
  // Map the hostnames to their corresponding API URLs
  const hostDomainMap = {
    "vendors.intermesh.net": "https://vendors.intermesh.net/api",
    "beta-vendors.intermesh.net": "https://beta-vendors.intermesh.net/api",
    "dev-vendors.intermesh.net": "https://dev-vendors.intermesh.net/api",
  };
  // Return the API URL based on the current host, default to localhost if not found
  return hostDomainMap[window.location.host] || "http://localhost:1300/api";
};

// Base URL of the WebERP host that serves the DSR, WhatsApp, Invoice and
// Activity Chart pages the app links to or embeds.
//
// These used to be written out in full in each component, always pointing at
// production, so the beta build loaded live ERP pages. Testing against
// beta then meant editing the URL by hand, which is how a beta host once
// reached a release branch.
export const erpDomain = () => {
  const hostDomainMap = {
    "vendors.intermesh.net": "https://weberp.intermesh.net",
    "beta-vendors.intermesh.net": "https://beta-pg-erp.intermesh.net",
  };
  // Anything else -- local development -- uses beta, never production.
  return hostDomainMap[window.location.host] || "https://beta-pg-erp.intermesh.net";
};

// Base URL of the vendors portal itself, for the PHP pages the app embeds or
// opens (Connect Seller, contact details, disposition admin).
export const portalDomain = () => {
  const hostDomainMap = {
    "vendors.intermesh.net": "https://vendors.intermesh.net",
    "beta-vendors.intermesh.net": "https://beta-vendors.intermesh.net",
  };
  // Anything else -- local development -- uses beta, never production.
  return hostDomainMap[window.location.host] || "https://beta-vendors.intermesh.net";
};